<template>
  <span class="align-middle">
    {{ expirationText }}
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { daysUntilClosure } from '../utils/vacancyUtils'

const props = defineProps({
  expirationDate: {
    type: String,
    required: true,
  },
})

const expirationText = computed(() => {
  const diffDays = daysUntilClosure(props.expirationDate)
  if (diffDays === 0) {
    return 'Eindigt vandaag'
  } else if (diffDays > 0) {
    return `Nog ${diffDays} dagen`
  } else {
    return 'Al gesloten'
  }
})
</script>
